enum permissions {
    'no' = 0, // 无权限
    'boss' = 1, // 1代表商家
    'consumer', // 2代表买家用户
    'employee', // 3代表商家授权员工
    'distributor', // 4代表分销者
    'both', // 5代表既是商家又是分销者
    'facilitator' = 6, // 6代表是服务商
}

export default permissions;
